import { useQuery } from "@tanstack/react-query";
import { fetchAuditLogs } from "./auditlogs.api";
import { keys } from "./keys";

export const useAuditLogsQuery = (params) => {
    return useQuery({
        queryKey: keys.auditLogs.list(params),
        queryFn: () => fetchAuditLogs(params),
        placeholderData: (prev) => prev
    });
};
